import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ isMobileDevice: boolean }>`
    flex-grow: 1;
    position: relative;
    max-height: 231px;
    min-height: 80px;
    margin-bottom: 20px;
    ${({ isMobileDevice }) =>
        !isMobileDevice &&
        css`
            margin-bottom: 40px;
        `}
`;

export const InnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const Desktop = styled.img`
    width: auto;
    height: 112%;
    position: absolute;
    top: -20px;
    transform: translate(-50%, 0);
    left: 50%;
`;

export const MobileImg = styled.img<{ isMobileDevice: boolean }>`
    position: absolute;
    height: 100%;
    width: auto;
    bottom: 0;
    transform: translate(-50%, 0%);
    left: 50%;
`;
